<template>
  <div class="container">
    <div v-if="candidate">

      <div class="header">
        {{ candidate.name.toUpperCase() }}
      </div>
      <div class="candidate-tile tile grid-item">
        <candidate-tile :candidate="candidate"/>

        <div v-if="candidate.youtube" class="video-container">
          <div class="separator"></div>

          <iframe class="ifr" 
                  :src="candidate.youtube" frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope;
                    picture-in-picture" allowfullscreen></iframe>
        </div>

        <div class="cnt">
          <div class="separator"></div>
            <div v-if="candidate && candidate.content">
              <div v-for="d in candidate.content">
                <div class="h2">
                  {{d.name}}
                </div>
                <div v-for="c in d.content">
                  <p v-html="c"></p>
                </div>
              </div>
            </div>
            <div class="back-button" @click="goBack()">
            <i class="fas fa-chevron-circle-left"></i>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import candidates from "@/data/candidates.json"
import CandidateTile from '@/components/CandidateTile.vue'

export default {
  name: 'CandidateTileDetails',
  components: {
    CandidateTile,
  },
  mounted() {
    this.candidateNr = this.$route.query.candidate
  },
  data() {
    return{
      candidateNr: -1,
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  },
  computed: {
    candidate() {
      return candidates.find(c => c.listNr == this.candidateNr)
    },
    candidatePhoto(){
      return '/img/candidate-photos/' + this.candidate.photo
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.photo{
  width: 100%;
}
.content{
  color: black;
}

.candidate-tile {
  max-width: 500px;
  display: inline-block;
  cursor: pointer;
  color: black;

  @include shadow;
  border-radius: $border-radius;
  margin: 10px;
  overflow: hidden;

  position: relative;

  background-color: white;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.h2 {
  color: black;
  font-size: 20pt;
  margin: 8pt;
}

.container{
}

.back-button {
  position: absolute;
  bottom: 20px;
  right: 20px;
  font-size: 40px;
}


.ifr{
  margin-top: 20px;
  width: 100%;
  height: 270px;
}

.video-container{
  margin:20px;
}

.cnt{
  margin:20px;
  margin-bottom: 100px;
}
</style>
